export enum FraudZipCoverageExclusionStrategy {
  NO_OP = "NO_OP",
  REPORT_ONLY = "REPORT_ONLY",
  BLOCK_COVERAGE = "BLOCK_COVERAGE",
}
